import * as util from "../core/util.js";
export const parsedType = data => {
  const t = typeof data;
  switch (t) {
    case "number":
      {
        return Number.isNaN(data) ? "NaN" : "number";
      }
    case "object":
      {
        if (Array.isArray(data)) {
          return "array";
        }
        if (data === null) {
          return "null";
        }
        if (Object.getPrototypeOf(data) !== Object.prototype && data.constructor) {
          return data.constructor.name;
        }
      }
  }
  return t;
};
const error = () => {
  const Sizable = {
    string: {
      unit: "characters",
      verb: "to have"
    },
    file: {
      unit: "bytes",
      verb: "to have"
    },
    array: {
      unit: "items",
      verb: "to have"
    },
    set: {
      unit: "items",
      verb: "to have"
    }
  };
  function getSizing(origin) {
    var _Sizable$origin;
    return (_Sizable$origin = Sizable[origin]) !== null && _Sizable$origin !== void 0 ? _Sizable$origin : null;
  }
  const Nouns = {
    regex: "input",
    email: "email address",
    url: "URL",
    emoji: "emoji",
    uuid: "UUID",
    uuidv4: "UUIDv4",
    uuidv6: "UUIDv6",
    nanoid: "nanoid",
    guid: "GUID",
    cuid: "cuid",
    cuid2: "cuid2",
    ulid: "ULID",
    xid: "XID",
    ksuid: "KSUID",
    datetime: "ISO datetime",
    date: "ISO date",
    time: "ISO time",
    duration: "ISO duration",
    ipv4: "IPv4 address",
    ipv6: "IPv6 address",
    cidrv4: "IPv4 range",
    cidrv6: "IPv6 range",
    base64: "base64-encoded string",
    base64url: "base64url-encoded string",
    json_string: "JSON string",
    e164: "E.164 number",
    jwt: "JWT",
    template_literal: "input"
  };
  return issue => {
    switch (issue.code) {
      case "invalid_type":
        return "Invalid input: expected ".concat(issue.expected, ", received ").concat(parsedType(issue.input));
      case "invalid_value":
        if (issue.values.length === 1) return "Invalid input: expected ".concat(util.stringifyPrimitive(issue.values[0]));
        return "Invalid option: expected one of ".concat(util.joinValues(issue.values, "|"));
      case "too_big":
        {
          var _issue$origin, _sizing$unit, _issue$origin2;
          const adj = issue.inclusive ? "<=" : "<";
          const sizing = getSizing(issue.origin);
          if (sizing) return "Too big: expected ".concat((_issue$origin = issue.origin) !== null && _issue$origin !== void 0 ? _issue$origin : "value", " to have ").concat(adj).concat(issue.maximum.toString(), " ").concat((_sizing$unit = sizing.unit) !== null && _sizing$unit !== void 0 ? _sizing$unit : "elements");
          return "Too big: expected ".concat((_issue$origin2 = issue.origin) !== null && _issue$origin2 !== void 0 ? _issue$origin2 : "value", " to be ").concat(adj).concat(issue.maximum.toString());
        }
      case "too_small":
        {
          const adj = issue.inclusive ? ">=" : ">";
          const sizing = getSizing(issue.origin);
          if (sizing) {
            return "Too small: expected ".concat(issue.origin, " to have ").concat(adj).concat(issue.minimum.toString(), " ").concat(sizing.unit);
          }
          return "Too small: expected ".concat(issue.origin, " to be ").concat(adj).concat(issue.minimum.toString());
        }
      case "invalid_format":
        {
          var _Nouns$_issue$format;
          const _issue = issue;
          if (_issue.format === "starts_with") {
            return "Invalid string: must start with \"".concat(_issue.prefix, "\"");
          }
          if (_issue.format === "ends_with") return "Invalid string: must end with \"".concat(_issue.suffix, "\"");
          if (_issue.format === "includes") return "Invalid string: must include \"".concat(_issue.includes, "\"");
          if (_issue.format === "regex") return "Invalid string: must match pattern ".concat(_issue.pattern);
          return "Invalid ".concat((_Nouns$_issue$format = Nouns[_issue.format]) !== null && _Nouns$_issue$format !== void 0 ? _Nouns$_issue$format : issue.format);
        }
      case "not_multiple_of":
        return "Invalid number: must be a multiple of ".concat(issue.divisor);
      case "unrecognized_keys":
        return "Unrecognized key".concat(issue.keys.length > 1 ? "s" : "", ": ").concat(util.joinValues(issue.keys, ", "));
      case "invalid_key":
        return "Invalid key in ".concat(issue.origin);
      case "invalid_union":
        return "Invalid input";
      case "invalid_element":
        return "Invalid value in ".concat(issue.origin);
      default:
        return "Invalid input";
    }
  };
};
export default function () {
  return {
    localeError: error()
  };
}